import React from 'react';
import { pressFeatures } from '../data/mock';

const Press = () => {
  // Don't render if no press features
  if (!pressFeatures || pressFeatures.length === 0) {
    return null;
  }

  return (
    <section id="press" className="py-24 md:py-32 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-poppins text-xs tracking-[0.4em] text-gray-500 mb-4 block">
            FEATURES
          </span>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wider text-white">
            Press & Publications
          </h2>
        </div>

        {/* Press Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pressFeatures.map((feature) => (
            <div
              key={feature.id}
              className="group relative aspect-[3/4] overflow-hidden cursor-pointer"
            >
              <img
                src={feature.image}
                alt={feature.publication}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="font-poppins text-xs tracking-wider text-gray-400">
                  {feature.date}
                </span>
                <h3 className="font-bebas text-2xl tracking-wider text-white mt-1">
                  {feature.publication}
                </h3>
                <p className="font-poppins text-sm text-gray-300">
                  {feature.title}
                </p>
              </div>
              
              {/* Hover Effect Line */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Press;
